/** UI strings for SuperAdminPageV2ProjectMvp — EN / UK (Ukrainian). */

const EN = {
  errLoadCards: 'Failed to load cards',
  errLoadSets: 'Failed to load card sets',
  errLoadGroups: 'Failed to load groups',
  errLoadUsers: 'Failed to load users',
  errLoadTagCatalog: 'Failed to load tag catalog',
  errLoadProjectTags: 'Failed to load project tags',
  errLoadProjectTagValues: 'Failed to load project tag values',
  copyLinkOk: 'Project login link copied.',
  copyLinkFail: 'Could not copy the link automatically.',
  confirmDeleteUser: 'Delete user?',
  title: 'SuperAdmin V2 MVP',
  logout: 'Log out',
  project: 'Project',
  projectLoginLink: 'Project login URL',
  copyLinkTitle: 'Copy link',
  languageLabelUk: 'UA',
  languageLabelEn: 'EN',
  tabDevice: 'Device',
  tabLocal: 'Global',
  tabLayout: 'Layout',
  tabUsers: 'Users',
  tabTelegram: 'Telegram',
  tabProject: 'Project',
  tabTags: 'Tags',
  tabAlarms: 'Alarms',
  tabTrends: 'Trends',
  tabLists: 'Lists',
  tabCards: 'Cards',
  tabSets: 'Sets',
  tabGroups: 'Groups',
  tabStations: 'Stations',
  tabCommands: 'Commands',
  tabBackup: 'Backup',
  attachUidLabel: 'Attach UID to project',
  attach: 'Attach',
  uidNotSelected: 'No UID selected',
  tagSearchLabel: 'Search by var/descr/formula',
  dataType: 'Data type',
  allTypes: 'All types',
  tagsCount: 'Tags',
  createTag: 'Create tag',
  actions: 'Actions',
  noTags: 'No tags',
  yes: 'Yes',
  no: 'No',
  editTagTitle: 'Edit tag #',
  newTagTitle: 'New tag',
  formulaHelper:
    'Examples: <UID_A.tag_a[1]> + <UID_B.tag_c[2]>; <global.total> + 1 (legacy: <project.total>)',
  helpProjectTagsTitle: 'Project tags',
  helpProjectTags: [
    'A new tag is written to trends immediately: period 60 seconds, deadband 0. This form does not show those fields and does not change them when you edit.',
    'var is unique and must start with a letter or underscore, then only letters, digits, and _. Deleting removes only this row; alarm rules that pointed at it stay.',
  ],
  helpProjectTagFormulaTitle: 'Formula',
  helpProjectTagFormula: [
    'Another project tag is read as <project.var>, in sort order and then id. A tag that is not computed yet or is inactive becomes 0. <global.var> is not recognized by this evaluator and also becomes 0.',
    'A station tag is <UID.tag[number]>. UID_A is the UID with the smallest id. A missing station or value becomes 0. A semicolon or curly braces outside tokens make the result empty.',
  ],
  helpProjectTagTypeTitle: 'Type',
  helpProjectTagType: 'The type is stored, but the formula result is not cast to it.',
  helpProjectTagActiveTitle: 'Active',
  helpProjectTagActive: 'An inactive tag is not computed, so value stays empty. Other formulas that refer to it get 0.',
  helpUserRoleTitle: 'Role',
  helpUserRole: 'The groups list is filtered only for role user. An admin sees every group; the visible-groups checkboxes are hidden and are not used for that role.',
  commandPriorityLabel: 'Command priority',
  commandPriorityWithValue: 'Command priority: {n}',
  commandPriorityHint: '0 = view only, 9 = maximum.',
  commandPriorityHintAdmin: 'You can assign a priority no higher than {n} (your own).',
  managedUsersHint: 'Users this admin will be able to manage. If the list is empty, the admin sees only themselves on the Users tab. Only accounts with the user role can be added — admins are not delegated.',
  managedUsersEmpty: 'This project has no regular users to delegate yet.',
  permissionsPolicyHint: 'Which tabs, sub-tabs and UIDs this admin can use inside the project. Clear every tick and leave quotas empty to use the default rights for the role.',
  helpUserPriorityTitle: 'Command priority',
  helpUserPriority: 'A command button stays available when this number is greater than or equal to the template required_priority. A template with required_priority 0 still runs at priority 0.',
  helpVisibleGroupsTitle: 'Visible groups',
  helpVisibleGroups: 'A user sees only the checked groups, plus the starred default group. An empty list means no groups. The star also checks the group; unchecking that group clears the star.',
  helpCardSetsTitle: 'Card sets',
  helpCardSets: 'Template seed cards are not listed and are dropped from a set when you open it. Saving requires at least one card.',
  helpSetRadiusTitle: 'Set radius',
  helpSetRadius: 'Corner radius of the set box on the groups page, in pixels. A negative number is stored as 0. Empty or invalid becomes 6.',
  helpCardGapTitle: 'Card gap',
  helpCardGap: 'Space between cards inside the set, in pixels. A negative number is stored as 0. Empty or invalid becomes 2.',
  helpShowSetNameTitle: 'Set name',
  helpShowSetName: 'Off hides the set title on the groups page. If the switch was never saved, the title is shown.',
  helpGroupsTitle: 'Groups',
  helpGroups: 'Deleting a group clears it from users’ visible groups and clears the default-group star when it pointed here. Saving requires at least one set.',
  helpGroupColumnsTitle: 'Columns',
  helpGroupColumns: 'How many sets sit in one row on the groups page: 2, 3, or 4. Any other stored value is shown as 4.',
  helpTelegramEnabledTitle: 'Project Telegram',
  helpTelegramEnabled: 'Off stops every project bot, including the test. UID events then fall through to the UID bot only when no project bot matches that event.',
  helpTelegramChatsTitle: 'Chat IDs',
  helpTelegramChats: 'Separate ids with commas. Blank pieces are dropped. A bot with no token or no chat id is not saved and disappears after reload.',
  helpTelegramUidFilterTitle: 'UID filter',
  helpTelegramUidFilter: 'Empty means this bot receives UID events for every UID. A selected list limits UID alarms, connection, and system events. Project alarms ignore this list.',
  helpTelegramEventsTitle: 'Event types',
  helpTelegramEvents: 'Each button is independent and starts on. Project alarms use their own button and are not limited by the UID filter. An inactive bot is skipped entirely.',
  helpPermissionsTitle: 'Permissions',
  helpPermissions: [
    'Write also turns Read on. Delete turns Read and Write on. Clearing Read clears Write and Delete. Clearing Write clears Delete. Sub-rows follow the same rule.',
    'Sub-rows are shown only while the parent Read is on. A sub-row box that has not been set yet follows the parent row. Clearing parent Read hides the sub-rows but keeps their values; they show again when Read is turned back on.',
  ],
  helpEntitlementQuotasTitle: 'Quotas',
  helpEntitlementQuotas: 'An empty field removes the saved override and the plan default applies. It is not stored as zero. The checkbox means no limit. Turning that checkbox off also returns to the plan default, not to the number that was typed.',
  active: 'Active',
  cancel: 'Cancel',
  save: 'Save',
  create: 'Create',
  listsTitle: 'Lists',
  cardsTitle: 'Cards',
  newCard: 'New card',
  cardModeLabel: 'Card mode',
  filterAllCards: 'All',
  filterCustom: 'Custom',
  filterTemplate: 'Template',
  filterSeed: 'Seed templates only',
  filterGenerated: 'Generated only',
  noCardsFilter: 'No cards for this filter',
  noCardsYet: 'No cards yet',
  editCardWord: 'Edit card',
  newCardForm: 'New card',
  syncing: 'Syncing…',
  syncFromTemplate: 'Sync from template',
  name: 'Name',
  cardType: 'Card type',
  textAlign: 'Text alignment',
  alignLeft: 'Left',
  alignCenter: 'Center',
  alignRight: 'Right',
  lineHeight: 'Line height',
  paddingTop: 'Top padding (px)',
  paddingBottom: 'Bottom padding (px)',
  cardRadius: 'Card radius (px)',
  displayModesTitle: 'Display modes (list / detail / map × desktop / mobile)',
  displayBaseHint:
    'Base appearance: used everywhere unless a field is set under “Display modes” below.',
  displayModesHint:
    'Overrides base fields above. Empty fields in a mode inherit from base list_settings. Saved as list_settings.display_modes.',
  displayModeList: 'List (groups page)',
  displayModeDetail: 'Detail page',
  displayModeMap: 'Map hover tooltip',
  displayViewportDesktop: 'Desktop',
  displayViewportMobile: 'Mobile',
  displayModeUseBase: 'Default (use base)',
  mapPseudocodeLabel: 'Pseudocode for map tooltip',
  mapPseudocodeHelper:
    'If set, used on the map instead of the base pseudocode. Newlines allowed.',
  modePseudocodeLabel: 'Pseudocode override',
  modePseudocodeHelper:
    'Optional. If empty, this mode/device uses base (or legacy detail/map pseudocode).',
  templateModeOn: 'Template mode: ON',
  makeTemplate: 'Make this card a template',
  templateModeOff: 'Turn off template mode',
  templateUid: 'Template UID',
  selectUidPlaceholder: 'Select UID…',
  tabBasePage: 'Base page',
  tabDetail: 'Details',
  detailScreenHint: 'Detail screen settings for this card.',
  pseudocodeDetail: 'Pseudocode for detail page',
  detailPseudocodeHelper: 'If set, this pseudocode is used on the detail screen.',
  detailCardType: 'Card type (detail)',
  detailLayout: 'Detail page layout',
  detailPanelsTitle: 'Panels on detail page',
  detailPanelSvg: 'SVG',
  detailPanelCard: 'Card',
  detailPanelAlarms: 'Alarms',
  detailPanelTrends: 'Charts',
  detailWidthsHint: 'Drag the borders. Only panels that are turned on share the row.',
  detailHeightSvg: 'SVG height, px',
  detailHeightAlarms: 'Alarms block height, px',
  detailHeightInvalid: 'Height must be from 200 to 1400, or leave the field empty.',
  layoutInherit: 'As in SVG config (default)',
  layoutNone: 'No SVG — card/tags only',
  layoutSplit: 'SVG + card (split)',
  layoutSvgOnly: 'SVG only',
  layoutCardOnly: 'Card only (no SVG)',
  hideSvgSettings: 'Hide SVG settings',
  configureSvg: 'Configure SVG',
  uploadSvgFile: 'Upload SVG file',
  svgName: 'SVG name',
  pseudocode: 'Pseudocode',
  pseudocodeHelperTemplate:
    'Template mode: only UID tags with [0], e.g. <Boiler_1.bar[0]. Global: <global.tag> (legacy: <project.tag>).',
  pseudocodeHelperNormal: 'Tag: <uid_alias.tag[idx]>. Command: <uid_alias.cmd:NAME[idx]>. Example: <Boiler_1.bar[100]>',
  accordionPreview: 'Pseudocode preview',
  accordionListSettings: 'Extra options (list_settings JSON)',
  listSettingsJson: 'list_settings (JSON)',
  accordionTagHintTemplate: 'Template tag hints ([0] only)',
  accordionTagHintDrilldown: 'Drilldown tag hints',
  templateTagHintBody:
    'In template mode only UID tags with index [0] are listed. Click a row to insert into pseudocode.',
  uidLabel: 'UID',
  allUids: 'All UIDs',
  typeLabel: 'Type',
  allTags: 'All tags',
  regularTags: 'Regular',
  systemTags: 'System',
  projectTags: 'Project tags',
  allDataTypes: 'All data_type',
  searchUidTag: 'Search by UID / tag / idx / label',
  tagClickHint:
    'Click adds the tag or command to `pseudocode`. Manual items are disabled; items are built on save.',
  projectTagsCaption: 'Project tags',
  cardSetsTitle: 'Card sets',
  newSet: 'New set',
  setNamed: 'Set #',
  cardsCount: 'cards',
  noSets: 'No sets',
  editSetWord: 'Edit set',
  newSetForm: 'New set',
  saveCreateCount: 'Save / Create',
  setName: 'Set name',
  showSetNameOnGroups: 'Show set name on groups page',
  setRadius: 'Set radius (px)',
  cardGap: 'Gap between cards (px)',
  cardsSelected: 'Cards',
  selected: 'selected',
  searchCardsPlaceholder: 'Search cards…',
  cardTypeFilter: 'Card type',
  allCardTypes: 'All card types',
  cardModeFilter: 'Card mode',
  allScope: 'All',
  customOnly: 'Custom only',
  generatedOnly: 'Generated only',
  selectedOnly: 'Selected only',
  selectAll: 'Select all',
  clearSelection: 'Clear selection',
  clearFilters: 'Clear filters',
  groupsTitle: 'Groups',
  newGroup: 'New group',
  noName: 'Unnamed',
  setsCount: 'sets',
  noGroups: 'No groups',
  editGroupWord: 'Edit group',
  newGroupForm: 'New group',
  update: 'Update',
  groupName: 'Group name',
  groupShort: 'Group #',
  description: 'Description',
  searchSets: 'Search sets',
  groupColumnsPerRow: 'Columns per row (groups view)',
  usersTitle: 'Users',
  usersQuotaLabel: 'Users: {current} / {limit}',
  usersQuotaReached: 'User limit reached ({limit}). Remove a user or contact support to upgrade.',
  errQuotaMaxUsers: 'User limit reached for this project.',
  errAdminPermissionsNoTab: 'Enable read access on at least one tab for the project admin.',
  newUser: 'New user',
  editUserWord: 'Edit user',
  username: 'Username',
  newPasswordOptional: 'New password (optional)',
  password: 'Password',
  roleLabel: 'Role',
  defaultGroup: 'Default group',
  noGroup: 'No group',
  saveUserFirst: 'Save the user, then pick a group',
  visibleGroupsTitle: 'Visible groups',
  defaultGroupStar: '+ default group (star)',
  makeDefaultGroup: 'Set as default group',
  afterSaveOnly: 'Available after save',
  managedGroupsTitle: 'Groups this admin can assign',
  svgConfigsTitle: 'SVG configs',
  svgConfigsIntro:
    'Full SVG management is on the Layout level. Here you create and edit UID-level configs used by second-level cards.',
  svgNew: 'New',
  svgRefresh: 'Refresh',
  colId: 'ID',
  open: 'Open',
  delete: 'Delete',
  editSvgWord: 'Edit SVG',
  newSvgConfig: 'New SVG config',
  svgContent: 'SVG content',
  tagMappingsJson: 'tag_mappings (JSON)',
  displayRulesJson: 'display_rules (JSON)',
  preserveSettingsJson: 'preserve_settings (JSON)',
  parseSvgTags: 'Parse tags from SVG',
  telegramTitle: 'Telegram',
  telegramIntro:
    'Used for notifications (tags / alarm rules). Per-station UID Telegram is configured on each UID tab.',
  bots: 'Bots',
  newBot: 'New bot',
  activeOnly: 'Active only',
  noBotsToShow: 'No bots to show',
  botNamed: 'Bot #',
  activeState: 'Active',
  inactiveState: 'Inactive',
  editBot: 'Edit bot',
  telegramSettings: 'Telegram settings',
  loading: 'Loading…',
  telegramReload: 'Reload',
  saving: 'Saving…',
  enableTelegram: 'Enable Telegram',
  botTitle: 'Bot name',
  botToken: 'Bot token',
  chatIds: 'Chat IDs (comma-separated)',
  uidFilterEmptyAll: 'UID filter (empty = all UIDs)',
  selectUidPlaceholder2: 'Select UIDs',
  botActive: 'Bot active',
  toggleProjectAlarms: 'Project alarms',
  toggleUidAlarms: 'UID alarms/warnings',
  toggleConn: 'Connection loss/restore',
  toggleSys: 'System UID messages',
  pickOrCreateBot: 'Pick a bot on the left or create one.',
  testSend: 'Test send',
  testMessage: 'Test message',
  sending: 'Sending…',
  sendTest: 'Send test',
  trendSettingsTitle: 'Trend settings',
  trendSettingsIntro: 'Project tag trending: enable, period, deadband.',
  colTag: 'Tag',
  colTrending: 'Trending',
  colPeriod: 'Period (sec)',
  colDeadband: 'Deadband',
  noUsers: 'No users',
  projectInfoTitle: 'Project info',
  projectStatus: 'Project status',
  projectStatusOnline: 'Online',
  projectStatusOffline: 'Offline',
  projectDbSize: 'DB size',
  projectDbLargestTables: 'Largest tables',
  projectEntities: 'Entities',
  projectRuntime: 'Runtime',
  transferTitle: 'Project transfer',
  transferTarget: 'Target superadmin',
  transferCreate: 'Create transfer request',
  transferIncoming: 'Incoming requests',
  transferOutgoing: 'Outgoing requests',
  transferAccept: 'Accept',
  transferReject: 'Reject',
  transferCancel: 'Cancel',
  transferNoRequests: 'No transfer requests',
  transferReason: 'Reason (optional)',
  transferExpiresAt: 'Expires at',
  transferStatus: 'Status',
  transferCreatedOk: 'Transfer request created',
  transferActionOk: 'Transfer request updated',
  transferActionErr: 'Transfer operation failed',
  // Project backup block (phase 1-2 of docs/04-project/PROJECT_BACKUP_PLAN.md)
  projectBackupTitle: 'Project backup',
  projectBackupIntro:
    'Download or restore the project configuration. You can also include a snapshot (latest values and active events) or a 1, 7 or 30 day window of trends, project tag values and events.',
  projectBackupDataMode: 'Data',
  projectBackupDataNone: 'Configuration only',
  projectBackupDataSnapshot: 'Snapshot',
  projectBackupDataWindow: 'Time window',
  projectBackupDataDays: 'Days',
  projectBackupExport: 'Download backup',
  projectBackupImport: 'Choose backup file...',
  projectBackupIncludeSecrets: 'Include secrets (passwords, telegram tokens)',
  projectBackupSecretsHint:
    'Without this flag the archive contains no password hashes or telegram tokens.',
  projectBackupPreviewTitle: 'Backup contents',
  projectBackupManifestSource: 'Source project',
  projectBackupManifestExportedAt: 'Exported at',
  projectBackupManifestUids: 'UID codes',
  projectBackupManifestSecrets: 'Secrets included',
  projectBackupManifestExtraUids:
    'UIDs attached to this project but not in the archive (will be left untouched):',
  projectBackupConfirmReplace:
    'I understand that the configuration sections from this archive will replace the current ones.',
  projectBackupConfirmSnapshot:
    'I understand that the configuration sections from this archive will replace the current ones, and that snapshot points and active events are added only when that key is not already present. History outside the snapshot stays.',
  projectBackupConfirmWindow:
    'I understand that the configuration sections from this archive will replace the current ones, and that trend points, project tag values and closed events inside the archive window will be replaced by this file. Active events that are not in the file stay active.',
  projectBackupManifestData: 'Data mode',
  projectBackupManifestWindow: 'Window',
  projectBackupManifestCounts: 'Rows',
  projectBackupApply: 'Restore backup',
  projectBackupExporting: 'Preparing backup...',
  projectBackupPreviewing: 'Reading archive...',
  projectBackupApplying: 'Restoring...',
  projectBackupSuccess: 'Backup restored',
  projectBackupExportError: 'Backup download failed',
  projectBackupPreviewError: 'Archive is not readable',
  projectBackupImportError: 'Backup restore failed',
  projectBackupResultTitle: 'Restore summary',
  projectBackupResultSections: 'Sections',
  projectBackupResultErrors: 'Errors',
  // Personal cabinet (superadmin home)
  cabinetTitle: 'Personal cabinet',
  cabinetSubtitle: 'Manage projects and device profiles (UID)',
  accountMenuTooltip: 'Account and settings',
  loginLinkTooltip: 'Copy project login link',
  cabinetLinkPrimary: 'Personal cabinet',
  cabinetLinkSecondary: 'Projects and UIDs',
  myProjects: 'My projects',
  addProject: 'Add project',
  addUid: 'Add UID',
  projectsCount: '{count} projects',
  freeUidsCount: '{count} free UIDs',
  freeUidsTitle: 'Free UIDs',
  emptyCabinet: 'No projects yet.',
  emptyCabinetHint: 'Add a project or a UID to get started.',
  allUidsAttached: 'All UIDs are attached to projects.',
  colName: 'Name',
  colPlan: 'Plan',
  colActions: 'Actions',
  openProject: 'Open',
  cabinetViewProjectInfo: 'Project info',
  cabinetProjectInfoModules: 'Connected modules',
  cabinetProjectInfoQuotas: 'Quotas',
  cabinetProjectInfoUids: 'UIDs',
  cabinetProjectInfoModuleOn: 'Enabled',
  cabinetProjectInfoModuleOff: 'Disabled',
  cabinetProjectInfoQuotaPlan: 'Plan default',
  cabinetProjectInfoUnlimited: 'Unlimited',
  cabinetProjectInfoLoadFailed: 'Failed to load project info',
  billingLoading: 'Loading balance…',
  billingDrawerTitle: 'Balance & billing',
  billingDrawerSuspendedHeader: 'Suspended projects',
  billingDrawerRenewalHeader: 'Upcoming charges — insufficient funds',
  billingDrawerProjectSuspendedDetail: 'Blocked · {amount} · next charge {date}',
  billingDrawerProjectRenewalDetail: 'Need {amount} by {date}',
  billingDrawerAllOk: 'All projects are funded for the next billing cycle.',
  billingWalletTitle: 'Account balance',
  billingBalance: 'Balance',
  billingDebt: 'Debt',
  billingAvailableCredit: 'Available to spend',
  billingOverdraftHint: 'Overdraft up to ${limit} — projects suspend if debt exceeds this.',
  billingSuspendedCount: '{count} project(s) suspended — top up your balance.',
  billingRenewalWarningCount: '{count} project(s) may fail the next charge — insufficient funds.',
  billingDebtLimitReached: 'Debt limit reached',
  billingSuspendedBadge: 'Suspended',
  billingRenewalBadge: 'Low balance',
  billingProjectSection: 'Billing',
  billingProjectSuspended: 'Project suspended — top up your balance to restore access.',
  billingProjectSuspendedTenant: 'Project is temporarily unavailable. Contact your service provider.',
  billingProjectRenewalWarning: 'Next charge {amount} on {date} — not enough balance.',
  billingMonthlyCost: 'Monthly cost',
  billingNextCharge: 'Next charge',
  billingNextChargeUnknown: 'Not scheduled',
  billingRecentCharges: 'Recent charges',
  billingNoChargesYet: 'No charges recorded yet.',
  billingLedgerTopUp: 'Top-up',
  billingLedgerProjectInitial: 'Project created',
  billingLedgerRenewal: 'Monthly renewal',
  billingLedgerAddon: 'Add-on (prorated)',
  billingLedgerAdjustment: 'Adjustment',
  purchaseInvoiceTitleProject: 'Confirm project purchase',
  purchaseInvoiceTitleUid: 'Confirm UID purchase',
  purchaseInvoiceIntro: 'The following will be charged from your account balance now. The monthly amount will be charged on each renewal date.',
  purchaseInvoiceChargeNow: 'Charge now',
  purchaseInvoiceMonthly: 'Monthly subscription',
  purchaseInvoiceChargeNowTotal: 'Total due now',
  purchaseInvoiceMonthlyRecurring: 'Then every month',
  purchaseInvoiceMonthlyHint: 'from project creation / renewal date',
  purchaseInvoiceBalanceAfter: 'Balance after payment',
  purchaseInvoiceBalanceCurrent: 'Current balance: {amount}',
  purchaseInvoiceAvailable: 'Available credit: {amount}',
  purchaseInvoiceInsufficient: 'Insufficient balance (overdraft limit reached). Top up or reduce the plan.',
  purchaseInvoiceConfirm: 'Confirm and pay',
  renameProject: 'Rename',
  renameUid: 'Rename UID',
  renameProjectTitle: 'Rename project',
  renameUidTitle: 'Rename UID',
  renameProjectSlugHint: 'Slug and URLs stay the same — only the display name changes.',
  renameUidCodeHint: 'UUID stays the same — only the display name changes.',
  helpBillingAccountTitle: 'Balance, debt and suspension',
  helpBillingAccount: [
    'Debt is how far the balance sits below zero. Spendable headroom is the balance plus the overdraft limit, so a balance of $10 against a $100 limit means $110 available.',
    'Suspension works per owner, not per project: once the debt reaches the limit, every project of this superadmin is suspended at once. A top-up recalculates it immediately and lifts the suspension from all of them as soon as the balance is above minus the limit.',
  ],
  helpBillingPeriodTitle: 'Billing period',
  helpBillingPeriod: [
    'The period is anchored to the day of the month the project was created, not to the first of the month. A project created on 15 March is billed 15.03–14.04, then 15.04–14.05, and so on.',
    'If that day does not exist in a shorter month, the last day of the month is used instead.',
  ],
  helpBillingMonthlyTitle: 'Monthly cost',
  helpBillingMonthly: [
    'The plan base price plus paid addon modules enabled on top of the plan, plus top-up for quotas raised above the plan default. The legacy_full plan counts as zero.',
    'UIDs are not billed yet — they are only recorded in the order log.',
  ],
  helpBillingNextChargeTitle: 'Next charge',
  helpBillingNextCharge: [
    'The date the current period ends. The money is taken when renewals are run, not exactly at midnight on that date.',
    'If the balance cannot cover it even with the overdraft, the project is suspended and its API starts answering 403 until the balance is topped up.',
  ],
  helpInvoiceTitle: 'Charged now and monthly',
  helpInvoice: [
    'Charged now is the one-off amount taken at this moment: a full first month for a new project, or the prorated difference for the days left in the current period when something is added mid-period.',
    'Monthly is what will be taken on every following renewal. Confirmation is blocked when the amount exceeds the available credit, that is the balance plus the overdraft.',
  ],
  helpTopUpTitle: 'Top-up',
  helpTopUp: [
    'The amount is added to the balance and written to the ledger as a top_up entry; the note is stored inside that entry.',
    'Suspension is recalculated right after: if the new balance is above minus the overdraft limit, every project of this superadmin is unsuspended at once.',
  ],
  helpRenameProjectTitle: 'Renaming a project',
  helpRenameProject:
    'The name is checked against the server as you type, with a short delay and ignoring this project itself. While the check is running or the name is taken, saving stays blocked and alternatives are offered below the field.',
  helpRenameUidTitle: 'Renaming a UID',
  helpRenameUid:
    'The name has to be unique within the project the UID belongs to. A clash is reported on save, not while typing.',
  helpCabinetQuotasTitle: 'Quotas and the plan',
  helpCabinetQuotas:
    'A quota that differs from the plan default is marked separately — those raised values are exactly what adds the top-up line to the monthly cost. An empty limit means unlimited.',
  helpUidAttachTitle: 'Rename and attach',
  helpUidAttach:
    'This dialog does two things in a row: it renames the UID if the name changed, then links it to the project by code. If the link step fails, the rename has already been applied.',
  projectStore: 'Service store',
  pinProject: 'Pin to top',
  unpinProject: 'Unpin',
  configure: 'Configure',
  attachTo: 'Assign to project',
  storeTooltip: 'Service modules',
  settingsSection: 'Settings',
  helpMenu: 'Help',
  examplesMenu: 'Examples',
  languageSection: 'Language',
  projectSection: 'Project',
  alarmsSection: 'Alarms',
  activeAlarmsOpen: 'Active alarms',
  activeAlarmsDialogTitle: 'Alarm acknowledgement',
  activeAlarmsDialogHint: 'Selected events will be marked as acknowledged and closed with the current server time. If the alarm condition is still present on site, the system may raise a new event.',
  activeAlarmsNoteLabel: 'Operator note (optional)',
  activeAlarmsListTitle: 'Open events',
  activeAlarmsEmpty: 'No open alarm events.',
  activeAlarmsSelectAll: 'Select all',
  activeAlarmsClose: 'Cancel',
  activeAlarmsAckSelected: 'Acknowledge selected',
  activeAlarmsAckAll: 'Acknowledge all',
  activeAlarmsRefresh: 'Refresh list',
  activeAlarmsStationShort: 'St.',
  activeAlarmsErrorFallback: 'Error',
  roleSuperadmin: 'Superadmin',
  roleAdmin: 'Project administrator',
  roleUser: 'User',
  newProjectTitle: 'New project',
  newUidTitle: 'New UID',
  slugLabel: 'Slug',
  slugHelper: 'Lowercase letters, digits and hyphens',
  planLabel: 'Plan',
  addonModulesLabel: 'Add-on modules',
  uidOnCreateLabel: 'UIDs at creation (optional)',
  uidRowPlaceholder: 'UID name {n}',
  addUidRow: 'Add UID',
  freeUidOption: 'No project (free)',
  projectSelectLabel: 'Target project',
  loadFailed: 'Failed to load data',
  createFailed: 'Operation failed',
  attachFailed: 'Assignment failed',
  uidNameConflict: 'This UID name is already used in the project.',
  renameUidToAttach: 'Rename UID',
  renameUidPrompt: 'Choose a unique name to attach this UID to the project.',
  uidRenameRequired: 'UID name is required',
  creating: 'Processing…',
  projectNameTaken: 'This project name is already taken.',
  projectNameSuggestions: 'Try one of these:',
  confirmDeleteProject: 'Delete project "{name}"? This action is irreversible — the project and all its data will be permanently removed.',
  deleteProjectFailed: 'Failed to delete project',
  deleteProjectOk: 'Project deleted',
  planStarterHint: 'Core + low quotas',
  planProHint: 'Trends, Telegram, SVG',
  planEnterpriseHint: 'Full feature set',
  addonTrends: 'Trends',
  addonTelegram: 'Telegram',
  addonTelegramAdvanced: 'Advanced TG',
  addonSvgHmi: 'SVG HMI',
  addonProjectTags: 'Project tags',
  addonAlarmRules: 'Alarm rules',
  addonCommandsAdvanced: 'Advanced commands',
  addonMaps: 'Maps',
  addonDebugTools: 'Debug tools',
  workspaceTitle: 'Project settings',
};

const UK = {
  errLoadCards: 'Не вдалося завантажити картки',
  errLoadSets: 'Не вдалося завантажити набори карток',
  errLoadGroups: 'Не вдалося завантажити групи',
  errLoadUsers: 'Не вдалося завантажити користувачів',
  errLoadTagCatalog: 'Не вдалося завантажити каталог тегів',
  errLoadProjectTags: 'Не вдалося завантажити project tags',
  errLoadProjectTagValues: 'Не вдалося завантажити значення project tags',
  copyLinkOk: 'Посилання для входу в проєкт скопійовано.',
  copyLinkFail: 'Не вдалося скопіювати посилання автоматично.',
  confirmDeleteUser: 'Видалити користувача?',
  title: 'SuperAdmin V2 MVP',
  logout: 'Вийти',
  project: 'Проєкт',
  projectLoginLink: 'Посилання входу в проєкт',
  copyLinkTitle: 'Копіювати посилання',
  languageLabelUk: 'UA',
  languageLabelEn: 'EN',
  tabDevice: 'Пристрої',
  tabLocal: 'Глобальні',
  tabLayout: 'Макет',
  tabUsers: 'Користувачі',
  tabTelegram: 'Telegram',
  tabProject: 'Проєкт',
  tabTags: 'Теги',
  tabAlarms: 'Аварії',
  tabTrends: 'Тренди',
  tabLists: 'Списки',
  tabCards: 'Картки',
  tabSets: 'Набори',
  tabGroups: 'Групи',
  tabStations: 'Станції',
  tabCommands: 'Команди',
  tabBackup: 'Backup',
  attachUidLabel: 'Привʼязати UID до проєкту',
  attach: 'Привʼязати',
  uidNotSelected: 'UID не обрано',
  tagSearchLabel: 'Пошук за var/descr/formula',
  dataType: 'Тип даних',
  allTypes: 'Усі типи',
  tagsCount: 'Теги',
  createTag: 'Створити тег',
  actions: 'Дії',
  noTags: 'Немає тегів',
  yes: 'Так',
  no: 'Ні',
  editTagTitle: 'Редагування тега #',
  newTagTitle: 'Новий тег',
  formulaHelper:
    'Приклади: <UID_A.tag_a[1]> + <UID_B.tag_c[2]>; <global.total> + 1 (legacy: <project.total>)',
  helpProjectTagsTitle: 'Проєктні теги',
  helpProjectTags: [
    'Новий тег одразу пишеться в тренди: період 60 секунд, deadband 0. Ця форма ці поля не показує і при редагуванні їх не змінює.',
    'var унікальний і має починатися з літери або підкреслення, далі лише літери, цифри і _. Видалення прибирає лише цей рядок; правила аварій, які на нього посилались, лишаються.',
  ],
  helpProjectTagFormulaTitle: 'Формула',
  helpProjectTagFormula: [
    'Інший проєктний тег читається як <project.var>, у порядку sort, потім id. Тег, який ще не порахований або вимкнений, дає 0. Запис <global.var> цей обчислювач не розпізнає і теж ставить 0.',
    'Тег станції — <UID.tag[номер]>. UID_A — це UID з найменшим id. Немає станції або значення — 0. Крапка з комою або фігурні дужки поза токенами роблять результат порожнім.',
  ],
  helpProjectTagTypeTitle: 'Тип',
  helpProjectTagType: 'Тип зберігається, але результат формули до нього не приводиться.',
  helpProjectTagActiveTitle: 'Активність',
  helpProjectTagActive: 'Вимкнений тег не обчислюється, тож value лишається порожнім. Інші формули, які на нього посилаються, отримують 0.',
  helpUserRoleTitle: 'Роль',
  helpUserRole: 'Список груп фільтрується лише для ролі user. Admin бачить усі групи; галочки видимих груп для нього ховаються і не використовуються.',
  commandPriorityLabel: 'Пріоритет команд',
  commandPriorityWithValue: 'Пріоритет команд: {n}',
  commandPriorityHint: '0 = лише перегляд, 9 = максимальний рівень.',
  commandPriorityHintAdmin: 'Ви можете видавати пріоритет не вище {n} (ваш власний).',
  managedUsersHint: 'Користувачі, якими керуватиме цей адміністратор. Якщо список порожній, на вкладці «Користувачі» він бачить лише себе. Додати можна лише облікові записи з роллю user — адміністратори не делегуються.',
  managedUsersEmpty: 'У проєкті ще немає звичайних користувачів для делегування.',
  permissionsPolicyHint: 'Які вкладки, підвкладки та UID доступні цьому адміністратору в проєкті. Зніміть усі позначки й залиште квоти порожніми, щоб діяли права за замовчуванням для ролі.',
  helpUserPriorityTitle: 'Пріоритет команд',
  helpUserPriority: 'Кнопка команди доступна, коли це число не менше за required_priority шаблону. Шаблон із required_priority 0 спрацьовує і при пріоритеті 0.',
  helpVisibleGroupsTitle: 'Видимі групи',
  helpVisibleGroups: 'Користувач бачить лише відмічені групи плюс групу із зіркою. Порожній список — жодної групи. Зірка також відмічає групу; зняття відмітки з неї прибирає зірку.',
  helpCardSetsTitle: 'Набори карток',
  helpCardSets: 'Картки-шаблони (seed) у список не потрапляють і при відкритті набору з нього викидаються. Для збереження потрібна хоча б одна картка.',
  helpSetRadiusTitle: 'Радіус набору',
  helpSetRadius: 'Радіус кутів рамки набору на сторінці груп, у пікселях. Від’ємне число зберігається як 0. Порожнє або нечислове стає 6.',
  helpCardGapTitle: 'Проміжок карток',
  helpCardGap: 'Відстань між картками всередині набору, у пікселях. Від’ємне число зберігається як 0. Порожнє або нечислове стає 2.',
  helpShowSetNameTitle: 'Назва набору',
  helpShowSetName: 'Вимкнення ховає заголовок набору на сторінці груп. Якщо перемикач ще не зберігали, заголовок показується.',
  helpGroupsTitle: 'Групи',
  helpGroups: 'Видалення групи прибирає її з видимих груп користувачів і скидає зірку групи за замовчуванням, якщо вона вказувала сюди. Для збереження потрібен хоча б один набір.',
  helpGroupColumnsTitle: 'Стовпці',
  helpGroupColumns: 'Скільки наборів стоїть в одному рядку на сторінці груп: 2, 3 або 4. Будь-яке інше збережене значення показується як 4.',
  helpTelegramEnabledTitle: 'Telegram проєкту',
  helpTelegramEnabled: 'Вимкнення зупиняє всіх ботів проєкту, включно з тестом. Події UID тоді йдуть на бота UID, лише якщо жоден бот проєкту не підійшов під цю подію.',
  helpTelegramChatsTitle: 'Chat ID',
  helpTelegramChats: 'Ідентифікатори через кому. Порожні фрагменти відкидаються. Бот без токена або без жодного chat id не зберігається і зникає після перезавантаження.',
  helpTelegramUidFilterTitle: 'Фільтр UID',
  helpTelegramUidFilter: 'Порожній список означає події UID для всіх UID. Обрані UID обмежують аварії UID, зв’язок і системні події. Проєктні аварії цей список не враховують.',
  helpTelegramEventsTitle: 'Типи подій',
  helpTelegramEvents: 'Кожна кнопка незалежна і спочатку увімкнена. Проєктні аварії йдуть своєю кнопкою і не залежать від фільтра UID. Неактивний бот пропускається повністю.',
  helpPermissionsTitle: 'Права',
  helpPermissions: [
    'Write також вмикає Read. Delete вмикає Read і Write. Зняття Read знімає Write і Delete. Зняття Write знімає Delete. Те саме для вкладених рядків.',
    'Вкладені рядки видно лише поки у батьківського рядка увімкнено Read. Клітинка вкладеного рядка, яку ще не змінювали, повторює батьківський рядок. Зняття Read ховає вкладені рядки, але не стирає їх: вони з’являться знову, коли Read увімкнути.',
  ],
  helpEntitlementQuotasTitle: 'Квоти',
  helpEntitlementQuotas: 'Порожнє поле прибирає збережене перевизначення, і діє значення тарифу. Нуль при цьому не записується. Прапорець означає без ліміту. Якщо його зняти, знову діє тариф, а не число, яке було введено.',
  active: 'Активний',
  cancel: 'Скасувати',
  save: 'Зберегти',
  create: 'Створити',
  listsTitle: 'Списки',
  cardsTitle: 'Картки',
  newCard: 'Нова картка',
  cardModeLabel: 'Режим карток',
  filterAllCards: 'Усі',
  filterCustom: 'Кастом',
  filterTemplate: 'Шаблонні',
  filterSeed: 'Лише seed-шаблони',
  filterGenerated: 'Лише згенеровані',
  noCardsFilter: 'Немає карток за фільтром',
  noCardsYet: 'Картки ще не створені',
  editCardWord: 'Редагування картки',
  newCardForm: 'Нова картка',
  syncing: 'Синхронізація…',
  syncFromTemplate: 'Оновити за шаблоном',
  name: 'Назва',
  cardType: 'Тип картки',
  textAlign: 'Вирівнювання тексту',
  alignLeft: 'Ліворуч',
  alignCenter: 'По центру',
  alignRight: 'Праворуч',
  lineHeight: 'Міжрядковий інтервал',
  paddingTop: 'Відступ зверху (px)',
  paddingBottom: 'Відступ знизу (px)',
  cardRadius: 'Радіус картки (px)',
  displayModesTitle: 'Режими відображення (список / деталі / карта × desktop / mobile)',
  displayBaseHint:
    'Базовий вигляд: скрізь, доки поле не задане в «Режимах відображення» нижче.',
  displayModesHint:
    'Перекривають базові поля вище. Порожні поля в режимі успадковують базові list_settings. Зберігається як list_settings.display_modes.',
  displayModeList: 'Список (сторінка груп)',
  displayModeDetail: 'Сторінка деталей',
  displayModeMap: 'Підказка на карті (hover)',
  displayViewportDesktop: 'Десктоп',
  displayViewportMobile: 'Мобільний',
  displayModeUseBase: 'За замовчуванням (база)',
  mapPseudocodeLabel: 'Псевдокод для підказки на карті',
  mapPseudocodeHelper:
    'Якщо задано, на карті використовується замість базового псевдокоду. Дозволені переноси рядків.',
  modePseudocodeLabel: 'Перевизначення псевдокоду',
  modePseudocodeHelper:
    'Необовʼязково. Якщо порожньо — режим/пристрій бере базовий (або legacy detail/map псевдокод).',
  templateModeOn: 'Режим шаблону: УВІМК',
  makeTemplate: 'Зробити цю картку шаблоном',
  templateModeOff: 'Вимкнути режим шаблону',
  templateUid: 'UID шаблону',
  selectUidPlaceholder: 'Оберіть UID…',
  tabBasePage: 'Базова сторінка',
  tabDetail: 'Детально',
  detailScreenHint: 'Налаштування екрана «Детально» для цієї картки.',
  pseudocodeDetail: 'Pseudocode для сторінки «Детально»',
  detailPseudocodeHelper: 'Якщо заповнено, на екрані «Детально» використовується цей pseudocode.',
  detailCardType: 'Тип картки (детально)',
  detailLayout: 'Розкладка сторінки «Детально»',
  detailPanelsTitle: 'Що показувати на «Детально»',
  detailPanelSvg: 'SVG',
  detailPanelCard: 'Картка',
  detailPanelAlarms: 'Аварії',
  detailPanelTrends: 'Графіки',
  detailWidthsHint: 'Потягніть межу. Рядок ділять лише увімкнені панелі.',
  detailHeightSvg: 'Висота SVG, px',
  detailHeightAlarms: 'Висота блоку аварій, px',
  detailHeightInvalid: 'Висота має бути від 200 до 1400, або залиште поле порожнім.',
  layoutInherit: 'Як у конфігурації SVG (типово)',
  layoutNone: 'Без SVG — лише картка/теги',
  layoutSplit: 'SVG + картка (split)',
  layoutSvgOnly: 'Лише SVG',
  layoutCardOnly: 'Лише картка (без SVG)',
  hideSvgSettings: 'Сховати налаштування SVG',
  configureSvg: 'Налаштувати SVG',
  uploadSvgFile: 'Завантажити SVG файл',
  svgName: 'Імʼя SVG',
  pseudocode: 'Pseudocode',
  pseudocodeHelperTemplate:
    'Режим шаблону: лише UID-теги з [0], напр. <Boiler_1.bar[0]. Global: <global.tag> (legacy: <project.tag>).',
  pseudocodeHelperNormal: 'Тег: <uid_alias.tag[idx]>. Команда: <uid_alias.cmd:NAME[idx]>. Приклад: <Boiler_1.bar[100]>',
  accordionPreview: 'Попередній перегляд псевдокоду',
  accordionListSettings: 'Дод. параметри (list_settings JSON)',
  listSettingsJson: 'list_settings (JSON)',
  accordionTagHintTemplate: 'Підказка тегів шаблону (лише [0])',
  accordionTagHintDrilldown: 'Підказка тегів drilldown',
  templateTagHintBody:
    'У шаблонному режимі показані лише UID-теги з індексом [0]. Клік по рядку вставляє тег у pseudocode.',
  uidLabel: 'UID',
  allUids: 'Усі UID',
  typeLabel: 'Тип',
  allTags: 'Усі теги',
  regularTags: 'Звичайні',
  systemTags: 'Системні',
  projectTags: 'Project-теги',
  allDataTypes: 'Усі data_type',
  searchUidTag: 'Пошук за UID / tag / idx / label',
  tagClickHint:
    'Клік додає тег або команду в `pseudocode`. Ручне додавання items вимкнено; items формуються при збереженні.',
  projectTagsCaption: 'Project tags',
  cardSetsTitle: 'Набори карток',
  newSet: 'Новий набір',
  setNamed: 'Набір #',
  cardsCount: 'карток',
  noSets: 'Немає наборів',
  editSetWord: 'Редагування набору',
  newSetForm: 'Новий набір',
  saveCreateCount: 'Зберегти / Створити',
  setName: 'Назва набору',
  showSetNameOnGroups: 'Показувати назву набору на сторінці груп',
  setRadius: 'Радіус набору (px)',
  cardGap: 'Відстань між картками (px)',
  cardsSelected: 'Картки',
  selected: 'обрано',
  searchCardsPlaceholder: 'Пошук карток…',
  cardTypeFilter: 'Тип картки',
  allCardTypes: 'Усі типи карток',
  cardModeFilter: 'Режим карток',
  allScope: 'Усі',
  customOnly: 'Лише кастом',
  generatedOnly: 'Лише згенеровані',
  selectedOnly: 'Лише обрані',
  selectAll: 'Обрати всі',
  clearSelection: 'Зняти вибір',
  clearFilters: 'Очистити фільтри',
  groupsTitle: 'Групи',
  newGroup: 'Нова група',
  noName: 'Без імені',
  setsCount: 'наборів',
  noGroups: 'Немає груп',
  editGroupWord: 'Редагування групи',
  newGroupForm: 'Нова група',
  update: 'Оновити',
  groupName: 'Назва групи',
  groupShort: 'Група #',
  description: 'Опис',
  searchSets: 'Пошук наборів',
  groupColumnsPerRow: 'Стовпців у рядку (сторінка груп)',
  usersTitle: 'Користувачі',
  usersQuotaLabel: 'Користувачі: {current} / {limit}',
  usersQuotaReached: 'Ліміт користувачів вичерпано ({limit}). Видаліть користувача або зверніться до підтримки для апгрейду.',
  errQuotaMaxUsers: 'Досягнуто ліміт користувачів для цього проєкту.',
  errAdminPermissionsNoTab: 'Увімкніть read хоча б на одному табі для project admin.',
  newUser: 'Новий користувач',
  editUserWord: 'Редагування користувача',
  username: 'Імʼя користувача',
  newPasswordOptional: 'Новий пароль (опційно)',
  password: 'Пароль',
  roleLabel: 'Роль',
  defaultGroup: 'Група за замовчуванням',
  noGroup: 'Без групи',
  saveUserFirst: 'Збережіть користувача, потім оберіть групу',
  visibleGroupsTitle: 'Видимі групи',
  defaultGroupStar: '+ група за замовчуванням (зірка)',
  makeDefaultGroup: 'Зробити групою за замовчуванням',
  afterSaveOnly: 'Доступно після збереження',
  managedGroupsTitle: 'Групи, які admin може призначати',
  svgConfigsTitle: 'SVG конфіги',
  svgConfigsIntro:
    'Повне керування SVG перенесено на рівень Layout. Тут створюються та редагуються конфіги для UID.',
  svgNew: 'Новий',
  svgRefresh: 'Оновити',
  colId: 'ID',
  open: 'Відкрити',
  delete: 'Видалити',
  editSvgWord: 'Редагування SVG',
  newSvgConfig: 'Новий SVG конфіг',
  svgContent: 'SVG content',
  tagMappingsJson: 'tag_mappings (JSON)',
  displayRulesJson: 'display_rules (JSON)',
  preserveSettingsJson: 'preserve_settings (JSON)',
  parseSvgTags: 'Парсити теги з SVG',
  telegramTitle: 'Telegram',
  telegramIntro:
    'Для сповіщень (tags / alarm rules). Telegram по станціях UID налаштовується окремо у вкладці Telegram кожного UID.',
  bots: 'Боти',
  newBot: 'Новий бот',
  activeOnly: 'Лише активні',
  noBotsToShow: 'Немає ботів для відображення',
  botNamed: 'Бот #',
  activeState: 'Активний',
  inactiveState: 'Неактивний',
  editBot: 'Редагування бота',
  telegramSettings: 'Налаштування Telegram',
  loading: 'Завантаження…',
  telegramReload: 'Перезавантажити',
  saving: 'Збереження…',
  enableTelegram: 'Увімкнути Telegram',
  botTitle: 'Назва бота',
  botToken: 'Bot token',
  chatIds: 'Chat IDs (через кому)',
  uidFilterEmptyAll: 'UID фільтр (порожньо = усі UID)',
  selectUidPlaceholder2: 'Оберіть UID',
  botActive: 'Бот активний',
  toggleProjectAlarms: 'Проєктні алерти',
  toggleUidAlarms: 'UID аварії/попередження',
  toggleConn: 'Втрата/відновлення звʼязку',
  toggleSys: 'Системні UID-повідомлення',
  pickOrCreateBot: 'Оберіть бота зліва або створіть нового.',
  testSend: 'Тестове надсилання',
  testMessage: 'Тестове повідомлення',
  sending: 'Надсилання…',
  sendTest: 'Надіслати тест',
  trendSettingsTitle: 'Налаштування трендів',
  trendSettingsIntro: 'Трендування project-тегів: увімкнення, період, deadband.',
  colTag: 'Тег',
  colTrending: 'Трендується',
  colPeriod: 'Період (сек)',
  colDeadband: 'Deadband',
  noUsers: 'Немає користувачів',
  projectInfoTitle: 'Інформація про проєкт',
  projectStatus: 'Стан проєкту',
  projectStatusOnline: 'Онлайн',
  projectStatusOffline: 'Офлайн',
  projectDbSize: 'Розмір БД',
  projectDbLargestTables: 'Найбільші таблиці',
  projectEntities: 'Сутності',
  projectRuntime: 'Runtime',
  transferTitle: 'Передача проєкту',
  transferTarget: 'Цільовий суперадмін',
  transferCreate: 'Створити запит на передачу',
  transferIncoming: 'Вхідні запити',
  transferOutgoing: 'Вихідні запити',
  transferAccept: 'Підтвердити',
  transferReject: 'Відхилити',
  transferCancel: 'Скасувати',
  transferNoRequests: 'Запитів немає',
  transferReason: 'Причина (опційно)',
  transferExpiresAt: 'Діє до',
  transferStatus: 'Статус',
  transferCreatedOk: 'Запит на передачу створено',
  transferActionOk: 'Статус запиту оновлено',
  transferActionErr: 'Помилка операції передачі',
  projectBackupTitle: 'Резервна копія проєкту',
  projectBackupIntro:
    'Завантажити або відновити конфігурацію проєкту. Можна також додати знімок (останні значення й активні події) або вікно 1, 7 чи 30 діб трендів, значень проєктних тегів і подій.',
  projectBackupDataMode: 'Дані',
  projectBackupDataNone: 'Лише конфігурація',
  projectBackupDataSnapshot: 'Знімок',
  projectBackupDataWindow: 'Вікно часу',
  projectBackupDataDays: 'Діб',
  projectBackupExport: 'Завантажити бекап',
  projectBackupImport: 'Обрати файл бекапу...',
  projectBackupIncludeSecrets: 'Включити секрети (паролі, telegram-токени)',
  projectBackupSecretsHint:
    'Без цієї позначки в архіві немає хешів паролів та токенів телеграму.',
  projectBackupPreviewTitle: 'Вміст бекапу',
  projectBackupManifestSource: 'Проєкт-джерело',
  projectBackupManifestExportedAt: 'Створено',
  projectBackupManifestUids: 'Коди UID',
  projectBackupManifestSecrets: 'Містить секрети',
  projectBackupManifestExtraUids:
    'UID прив’язані до цього проєкту, але відсутні в архіві (залишаться без змін):',
  projectBackupConfirmReplace:
    'Я розумію, що секції конфігурації з цього архіву замінять поточні.',
  projectBackupConfirmSnapshot:
    'Я розумію, що секції конфігурації з цього архіву замінять поточні, а точки знімка й активні події додадуться лише якщо такого ключа ще немає. Історія поза знімком залишиться.',
  projectBackupConfirmWindow:
    'Я розумію, що секції конфігурації з цього архіву замінять поточні, а точки трендів, значення проєктних тегів і закриті події всередині вікна з архіву будуть замінені цим файлом. Активна подія, якої немає у файлі, залишиться активною.',
  projectBackupManifestData: 'Режим даних',
  projectBackupManifestWindow: 'Вікно',
  projectBackupManifestCounts: 'Рядки',
  projectBackupApply: 'Відновити з бекапу',
  projectBackupExporting: 'Готується бекап...',
  projectBackupPreviewing: 'Читаємо архів...',
  projectBackupApplying: 'Відновлення...',
  projectBackupSuccess: 'Бекап відновлено',
  projectBackupExportError: 'Не вдалося завантажити бекап',
  projectBackupPreviewError: 'Архів не вдалося прочитати',
  projectBackupImportError: 'Не вдалося відновити бекап',
  projectBackupResultTitle: 'Підсумки відновлення',
  projectBackupResultSections: 'Секції',
  projectBackupResultErrors: 'Помилки',
  cabinetTitle: 'Особистий кабінет',
  cabinetSubtitle: 'Керування проєктами та профілями пристроїв (UID)',
  accountMenuTooltip: 'Акаунт і налаштування',
  loginLinkTooltip: 'Копіювати посилання входу в проєкт',
  cabinetLinkPrimary: 'Особистий кабінет',
  cabinetLinkSecondary: 'Проєкти та UID',
  myProjects: 'Мої проєкти',
  addProject: 'Додати проєкт',
  addUid: 'Додати UID',
  projectsCount: '{count} проєктів',
  freeUidsCount: '{count} вільних UID',
  freeUidsTitle: 'Вільні UID',
  emptyCabinet: 'Проєктів поки немає.',
  emptyCabinetHint: 'Додайте проєкт або UID, щоб почати.',
  allUidsAttached: 'Усі UID привʼязані до проєктів.',
  colName: 'Назва',
  colPlan: 'План',
  colActions: 'Дії',
  openProject: 'Відкрити',
  cabinetViewProjectInfo: 'Інформація про проєкт',
  cabinetProjectInfoModules: 'Підключені модулі',
  cabinetProjectInfoQuotas: 'Квоти',
  cabinetProjectInfoUids: 'UID',
  cabinetProjectInfoModuleOn: 'Увімкнено',
  cabinetProjectInfoModuleOff: 'Вимкнено',
  cabinetProjectInfoQuotaPlan: 'За тарифом',
  cabinetProjectInfoUnlimited: 'Безліміт',
  cabinetProjectInfoLoadFailed: 'Не вдалося завантажити інформацію про проєкт',
  billingLoading: 'Завантаження балансу…',
  billingDrawerTitle: 'Баланс і білінг',
  billingDrawerSuspendedHeader: 'Призупинені проєкти',
  billingDrawerRenewalHeader: 'Наступні списання — не вистачає коштів',
  billingDrawerProjectSuspendedDetail: 'Заблоковано · {amount} · наступне {date}',
  billingDrawerProjectRenewalDetail: 'Потрібно {amount} до {date}',
  billingDrawerAllOk: 'На всі проєкти вистачає коштів для наступного періоду.',
  billingWalletTitle: 'Баланс акаунта',
  billingBalance: 'Баланс',
  billingDebt: 'Борг',
  billingAvailableCredit: 'Доступно до витрат',
  billingOverdraftHint: 'Овердрафт до ${limit} — проєкти блокуються, якщо борг перевищує ліміт.',
  billingSuspendedCount: '{count} проєкт(ів) призупинено — поповніть баланс.',
  billingRenewalWarningCount: '{count} проєкт(ів) — наступне списання може не пройти.',
  billingDebtLimitReached: 'Ліміт боргу досягнуто',
  billingSuspendedBadge: 'Призупинено',
  billingRenewalBadge: 'Мало коштів',
  billingProjectSection: 'Білінг',
  billingProjectSuspended: 'Проєкт призупинено — поповніть баланс для доступу.',
  billingProjectSuspendedTenant: 'Проєкт тимчасово недоступний. Зверніться до постачальника послуг.',
  billingProjectRenewalWarning: 'Наступне списання {amount} ({date}) — недостатньо коштів.',
  billingMonthlyCost: 'Щомісячна вартість',
  billingNextCharge: 'Наступне списання',
  billingNextChargeUnknown: 'Не заплановано',
  billingRecentCharges: 'Останні списання',
  billingNoChargesYet: 'Списань ще не було.',
  billingLedgerTopUp: 'Поповнення',
  billingLedgerProjectInitial: 'Створення проєкту',
  billingLedgerRenewal: 'Щомісячне продовження',
  billingLedgerAddon: 'Доп. модуль (пропорційно)',
  billingLedgerAdjustment: 'Коригування',
  purchaseInvoiceTitleProject: 'Підтвердження покупки проєкту',
  purchaseInvoiceTitleUid: 'Підтвердження покупки UID',
  purchaseInvoiceIntro: 'З вашого балансу зараз буде списано вказану суму. Щомісячна сума — у дату продовження проєкту.',
  purchaseInvoiceChargeNow: 'Списати зараз',
  purchaseInvoiceMonthly: 'Щомісячна підписка',
  purchaseInvoiceChargeNowTotal: 'До списання зараз',
  purchaseInvoiceMonthlyRecurring: 'Далі щомісяця',
  purchaseInvoiceMonthlyHint: 'від дати створення / продовження',
  purchaseInvoiceBalanceAfter: 'Баланс після оплати',
  purchaseInvoiceBalanceCurrent: 'Поточний баланс: {amount}',
  purchaseInvoiceAvailable: 'Доступно: {amount}',
  purchaseInvoiceInsufficient: 'Недостатньо коштів (ліміт овердрафту). Поповніть баланс або змініть план.',
  purchaseInvoiceConfirm: 'Підтвердити і сплатити',
  renameProject: 'Перейменувати',
  renameUid: 'Перейменувати UID',
  renameProjectTitle: 'Перейменувати проєкт',
  renameUidTitle: 'Перейменувати UID',
  renameProjectSlugHint: 'Slug і URL не змінюються — лише відображувана назва.',
  renameUidCodeHint: 'UUID не змінюється — лише відображувана назва.',
  helpBillingAccountTitle: 'Баланс, борг і блокування',
  helpBillingAccount: [
    'Борг — це наскільки баланс опустився нижче нуля. Доступно до витрати — баланс плюс ліміт овердрафту: при балансі $10 і ліміті $100 доступно $110.',
    'Блокування діє на власника, а не на окремий проєкт: щойно борг досягає ліміту, блокуються всі проєкти цього суперадміна одразу. Поповнення перераховує це негайно і знімає блокування з усіх, щойно баланс стає вищим за мінус ліміт.',
  ],
  helpBillingPeriodTitle: 'Біллінговий період',
  helpBillingPeriod: [
    'Період привʼязаний до дня місяця, коли створили проєкт, а не до першого числа. Проєкт, створений 15 березня, тарифікується 15.03–14.04, далі 15.04–14.05 і так далі.',
    'Якщо такого дня в коротшому місяці немає, береться останній день місяця.',
  ],
  helpBillingMonthlyTitle: 'Щомісячна вартість',
  helpBillingMonthly: [
    'База плану плюс платні додаткові модулі, увімкнені понад план, плюс доплата за квоти, підняті вище за типові для плану. План legacy_full рахується як нуль.',
    'UID поки не тарифікуються — вони лише фіксуються в журналі замовлень.',
  ],
  helpBillingNextChargeTitle: 'Наступне списання',
  helpBillingNextCharge: [
    'Дата, коли закінчується поточний період. Гроші списуються під час прогону продовжень, а не рівно опівночі цієї дати.',
    'Якщо балансу не вистачить навіть з овердрафтом, проєкт блокується, і його API починає відповідати 403, доки баланс не поповнять.',
  ],
  helpInvoiceTitle: 'Списання зараз і щомісяця',
  helpInvoice: [
    '«Списуємо зараз» — разова сума в цей момент: повний перший місяць для нового проєкту або пропорційна різниця за дні, що лишилися до кінця періоду, якщо щось додають усередині періоду.',
    '«Щомісяця» — те, що списуватиметься на кожному наступному продовженні. Підтвердження блокується, якщо сума перевищує доступний кредит, тобто баланс плюс овердрафт.',
  ],
  helpTopUpTitle: 'Поповнення',
  helpTopUp: [
    'Сума додається до балансу і пишеться в журнал як запис top_up; примітка зберігається всередині цього запису.',
    'Одразу після цього блокування перераховується: якщо новий баланс вищий за мінус ліміт овердрафту, з усіх проєктів цього суперадміна блокування знімається.',
  ],
  helpRenameProjectTitle: 'Перейменування проєкту',
  helpRenameProject:
    'Назва перевіряється на сервері під час набору, із невеликою затримкою і без урахування самого цього проєкту. Поки триває перевірка або назва зайнята, зберегти не можна, а під полем пропонуються варіанти.',
  helpRenameUidTitle: 'Перейменування UID',
  helpRenameUid:
    'Назва має бути унікальною в межах проєкту, до якого привʼязаний UID. Про збіг повідомляється при збереженні, а не під час набору.',
  helpCabinetQuotasTitle: 'Квоти і план',
  helpCabinetQuotas:
    'Квота, що відрізняється від типової для плану, позначається окремо — саме такі підняті значення додають доплату до щомісячної вартості. Порожнє обмеження означає «без ліміту».',
  helpUidAttachTitle: 'Перейменування і привʼязка',
  helpUidAttach:
    'Це вікно робить дві дії поспіль: перейменовує UID, якщо назву змінили, а потім привʼязує його до проєкту за кодом. Якщо привʼязка не вдалася, перейменування вже застосоване.',
  projectStore: 'Магазин модулів',
  pinProject: 'Закріпити зверху',
  unpinProject: 'Відкріпити',
  configure: 'Налаштувати',
  attachTo: 'Призначити проєкту',
  storeTooltip: 'Сервісні модулі',
  settingsSection: 'Налаштування',
  helpMenu: 'Довідка',
  examplesMenu: 'Приклади',
  languageSection: 'Мова',
  projectSection: 'Проєкт',
  alarmsSection: 'Аварії',
  activeAlarmsOpen: 'Активні аварії',
  activeAlarmsDialogTitle: 'Квитування аварій',
  activeAlarmsDialogHint: 'Обрані події будуть позначені як квитовані та закриті з поточним часом сервера. Якщо аварійна умова на обʼєкті залишається, система може зареєструвати нову подію.',
  activeAlarmsNoteLabel: 'Примітка оператора (необовʼязково)',
  activeAlarmsListTitle: 'Відкриті події',
  activeAlarmsEmpty: 'Відкритих аварійних подій немає.',
  activeAlarmsSelectAll: 'Вибрати все',
  activeAlarmsClose: 'Скасувати',
  activeAlarmsAckSelected: 'Квитувати обрані',
  activeAlarmsAckAll: 'Квитувати всі',
  activeAlarmsRefresh: 'Оновити список',
  activeAlarmsStationShort: 'Ст.',
  activeAlarmsErrorFallback: 'Помилка',
  roleSuperadmin: 'Суперадмін',
  roleAdmin: 'Адміністратор проєкту',
  roleUser: 'Користувач',
  newProjectTitle: 'Новий проєкт',
  newUidTitle: 'Новий UID',
  slugLabel: 'Slug',
  slugHelper: 'Латиниця, цифри та дефіс',
  planLabel: 'План',
  addonModulesLabel: 'Додаткові модулі',
  uidOnCreateLabel: 'UID при створенні (необовʼязково)',
  uidRowPlaceholder: 'Назва UID {n}',
  addUidRow: 'Додати UID',
  freeUidOption: 'Без проєкту',
  projectSelectLabel: 'Цільовий проєкт',
  loadFailed: 'Не вдалося завантажити дані',
  createFailed: 'Операцію не виконано',
  attachFailed: 'Помилка призначення',
  uidNameConflict: 'Таке імʼя UID уже використовується в цьому проєкті.',
  renameUidToAttach: 'Перейменувати UID',
  renameUidPrompt: 'Оберіть унікальну назву, щоб привʼязати UID до проєкту.',
  uidRenameRequired: 'Назва UID обовʼязкова',
  creating: 'Обробка…',
  projectNameTaken: 'Таку назву проєкту вже зайнято.',
  projectNameSuggestions: 'Спробуйте одну з цих:',
  confirmDeleteProject: 'Видалити проєкт «{name}»? Цю дію не можна скасувати — проєкт і всі його дані будуть безповоротно видалені.',
  deleteProjectFailed: 'Не вдалося видалити проєкт',
  deleteProjectOk: 'Проєкт видалено',
  planStarterHint: 'Core + низькі квоти',
  planProHint: 'Trends, Telegram, SVG',
  planEnterpriseHint: 'Повний набір',
  addonTrends: 'Trends',
  addonTelegram: 'Telegram',
  addonTelegramAdvanced: 'Advanced TG',
  addonSvgHmi: 'SVG HMI',
  addonProjectTags: 'Project tags',
  addonAlarmRules: 'Alarm rules',
  addonCommandsAdvanced: 'Advanced commands',
  addonMaps: 'Maps',
  addonDebugTools: 'Debug tools',
  workspaceTitle: 'Налаштування проєкту',
};

export function getSuperadminV2(lang) {
  return lang === 'uk' ? UK : EN;
}
